// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"bp-z","breadcrumbForward":"cp-z","breadcrumbBack":"dp-z","selected":"ep-z"};